import { render, staticRenderFns } from "./SpringConsultActions.vue?vue&type=template&id=6c56ef2a&"
import script from "./SpringConsultActions.vue?vue&type=script&lang=js&"
export * from "./SpringConsultActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports